module.exports = __webpack_public_path__ + "media/closecombat.f2809226.wav";